module.exports = __webpack_public_path__ + "assets/img/0f2df84e8ecd5fd06bd0342a703a4a3f.svg";